import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[sliderTemplate]',
    standalone: false
})
export class SliderTemplateDirective<T> {
  constructor(public template: TemplateRef<T>) {}
}
